import { ReactNode } from 'react';

import styles from './ProjectsGrid.module.scss';

export default function ProjectsGrid(props: { children?: ReactNode }) {
    const { children } = props;
    return <div className={styles.grid}>{children}</div>;
}
